<template>
  <!-- home v2 -->  
  <div class="home">
    <main>
      <section class="no-parallax reveal active" style="background-color:#0d3553">
        <home-pros></home-pros>
      </section>

      <section class="no-parallax reveal fixed-bg bgConnect">
        <home-connect></home-connect>
      </section>

      <section class="no-parallax reveal">
        <home-pros></home-pros>
      </section>

      <section class="reveal fixed-bg">
          <div style="width:100%;">
            <div class="container" style="width:50%;text-align:center;padding-top:50px;">
              <div class="split-text title"><p st>C1 Conical Connection Implant</p></div>
              <div class="split-text subtitle"><p>The C1 implant is a powerful player in the MIS conical connection implant fleet and offers a versatile solution for all clinical indications. This simple, accurate and proven implant system was designed with a conical connection and optimizes biological benefits and clinical and esthetic results. </p></div>        
            </div>
            <div class="xrBtn">
                <a href="/Products/MGUIDE" class="white_btn animation_up">
                <span class="title">Read More</span><i class="fal fa-chevron-right pl-s" ></i>
                </a>
            </div>
          </div>
      </section>   

      <section class="no-parallax reveal white">
        <home-boxes></home-boxes>
      </section>


    </main>

    <!-- <home-section></home-section> -->

  </div>
</template>

<style lang="stylus">  
main {
  __height: 100vh;
  perspective: 2px;
  overflow-x: hidden;
  overflow-y: auto;  
}

section {
  transform-style: preserve-3d;
  position: relative;
  height: calc(100vh - 120px);
  color: white;
}




.fixed-bg
{
  width: 100%;
  position:relative;
  display: flex;
  align-items: center;  
  background-color: #0d3553;
}
.fixed-bg::before 
{
  z-index:-10;
  content: ' ';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background-image: url('https://www.mis-implants.com/upload/Home/Global/c1.webp');
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
  background-attachment:fixed;
}

.fixed-bg.bgConnect
{
  background-color: #041f34 !important;
}
.fixed-bg.bgConnect::before 
{
  opacity: 1;
  background-image: url('https://www.mis-implants.com/upload//Products/Prosthetic-Options/Screw-Retained/CONNECT/CONNECT_Page.png') !important;
  transition: ease-in all 0.9s;
}
.reveal.active.fixed-bg.bgConnect::before 
{
  opacity: 0.4 !important;
}




.__fixed-bg::before {
  content: '';
  background-attachment:fixed;
  background: url("https://www.mis-implants.com/upload/Home/Global/c1.webp");
  background-size: cover;

}


.no-parallax {
  background-color: #1778bb;
  z-index: 999;
  display: flex;
  align-items: center;
}
.no-parallax.white
{
  background-color:#fff;
  width: 100%;
}
.no-parallax.black
{
  background-color:#000;
  width: 100%;
}

section h1 {
  text-align: center;
  font-size: 4rem;
  font-family: sans-serif;
}

.parallax
{
  display: flex;
  align-items: center;
}
.parallax h1 {
  width: 60%;
  font-size: 2rem;
}

.parallax::after {
  content: " ";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateZ(-1px) scale(1.5);
  background-size: 100%;
  z-index: -1;
}

.bg::after {
  background: linear-gradient(rgba(5, 30, 50, 0.9), rgba(5, 30, 50, 0.9)),
    url("https://www.mis-implants.com/upload/Home/Global/c1.webp");
  background-size: cover;
}
</style>

<script>
import { mapActions, mapState } from "vuex";
import hpBox from './hp/hpBox.vue';
import { splitLines }         from "@/utils";
import HomeSection from "@/views/hp/hpSection1.vue";
import HomeConnect from "@/views/hp/hpConnect.vue";
import HomeBoxes from "@/views/hp/hpBoxes.vue";
import HomePros from "@/views/hp/hpPros.vue";
import Search from '../components/search/Search.vue';

// @ is an alias to /src
export default {
  components: { hpBox,HomeSection,HomeConnect,HomeBoxes,HomePros, Search },
  name: "home2",
  data() {
    return {
      midBoxesW:400,
      slider: null,
      boxes: null,
      code: "",
      logoReady: false,
      logoMove: false,
      animateLogo: false,
      sloganReady: false,
      animateLetters: false,
      ro: null,
      elementSizes: [],
      resizeTrig: -1,
      observed: null
    };
  },
  watch: {
    pageLayoutData() {
      // console.log("PAGE DATA IS HERE: ", this.pageLayoutData);
      this.setPageReady(true);
    },
  },
  created() {
    //this.setPageReady(false);    
    this.initScrollListener();
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandler);
  },
  async mounted() {
    //this.initText();
    this.initRouteByPath(`Home/${this.$route.params.locale || "global"}`);
  },
  methods: {
    ...mapActions(["initRouteByPath", "setPageReady", "dirtifyHome"]),
    initScrollListener() {
      window.addEventListener("scroll", this.scrollHandler, false);
    },
    scrollHandler() {
      this.pageScrollTop = document.documentElement.scrollTop;
      this.revealElements();
    },
    revealElements() {
      var reveals = document.querySelectorAll(".reveal");
      for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 350;
        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add("active");
        } else {
          //reveals[i].classList.remove("active");
        }
      }
    },
    initText()
    {      
      //var splitBlocks = document.getElementsByClassName('split-text');
      //for (var i = 0; i < splitBlocks.length; i++) {splitLines(splitBlocks[i]); }
    },
  },
  computed: {
    ...mapState(["pageLayoutData", "locale", "dirtyHome"]),
  }
};
</script>



<style lang="stylus" scoped>
.fade-from-top
  &-enter-active
  &-leave-active
    transition opacity 2s ease-out, transform 2s ease-out-cubic
  &-enter
  &-leave-to
    transform translateY(-50%) !important
  &-enter-to
  &-leave
    opacity 1 !important
    transform translateY(0) !important
.home
  position relative
  top 33px
  min-height 120vh
  .mis-promo
    // padding 60px 0
    // +below(768px)
    padding 44px 0
    +below(415px)
      _flex(row, wrap, center, center)
      padding 30px 0
  h2
    height 100%
    min-height 70px
    min-width 34vw
    position relative
    _flex(row, nowrap, baseline, center, true)
    +below(1100px)
      _flex(row, nowrap, flex-bottom, center, true)
      min-height auto
    .slogan-box
      color blue_primary
      border-left 1px solid blue_primary
      background #fff
      font-size responsive 27px 52px
      font-weight 500
      opacity 0
      overflow hidden
      & >>> .letter
        opacity 0
        display inline-block
        transform translateY(100%)
        position relative
        font-weight 300 !important
    &.logo-move
      .mis-logo
        left 0
        transform translateX(0)
    &.logo-ready
      .slogan-box.animate
        opacity 1
        & >>> .letter
          opacity 1
          transform translateY(0)
    &.next
      .mis-logo
        position static
        +below(1100px)
          height auto
        +below(415px)
          height 27px
  h3
    font-size responsive 14px 28px
    color gray_8
    &.logo-extra
      opacity 0
      transform translateY(-50%)
      transition opacity 0.4s ease-out, transform 0.4s ease-out
      &.show
        opacity 1
        transform translateY(0)
</style>
